import { t } from "i18next";

import { getIntValue } from "@/utilities/number";

import { CRITERIA_I18N_KEY_PREFIX } from "./constants";

export const getLevelKey = (level: number) =>
  `${CRITERIA_I18N_KEY_PREFIX}.${level}`;

export const getLevelDisplayLabel = (level: number) => t(getLevelKey(level));

export const gridCriteriaMapper = ({
  level,
  description = "",
  disabled = false,
}: {
  level: number;
  description?: string;
  disabled?: boolean;
}) => ({
  value: getIntValue(level),
  name: getLevelDisplayLabel(level),
  description: description ?? "", // explicit null handled same as undefined,
  disabled,
});

export const simpleDropdownCriteriaMapper = (level: number) => ({
  value: getIntValue(level),
  name: getLevelDisplayLabel(level),
  description: t("form:staticField.severity.formEditorSample.name", {
    level,
  }),
});
